module.exports = __webpack_public_path__ + "img/logout-image.151ce7b3.png";